import React, { useEffect, useState } from "react";
import { notification, Pagination } from "antd";
import ResumeSearchSec from "./allResumes/ResumeSearchSec";
import ResumeTable from "./allResumes/ResumeTable";
import Utils from "../../../utils/Utils";
import WebUtils from "../../../utils/WebUtils";
import {
  deleteResume,
  getAllResumesApi,
  getResumeDropDown,
  viewResume,
} from "../../../api/b2b-candidate";
import { renameResumeFile } from "../../../api/org-admin";

const AllResumesMain = ({ setLoading }) => {
  const userDetail = Utils.getUserDetail();
  const [resumes, setResumes] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [sortBy, setSortBy] = useState("SORT_BY_CREATION_DATE_DESC");
  const [currentPage, setCurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(5);
  const [pageSize, setPageSize] = useState(5);
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [unAssignStudentFlag, setUnAssignStudentFlag] = useState(false);
  const [resumeState, setResumeState] = useState("ALL");
  const [deleteResumeTrigger, setDeleteResumeTrigger] = useState(0);
  const [singleSkeletonLoading, setSingleSkeletonLoading] = useState(false);

  const getAllResumes = (currPage, pageSize, searchInput) => {
    const url = `${getAllResumesApi}?organizationId=${
      userDetail?.organizationId || null
    }&userIdentifier=${userDetail?.userIdentifier}&sortBy=${sortBy}&resumeOptimizerState=${resumeState}&pageNumber=${currPage}&pageSize=${pageSize}&searchInput=${searchInput}`;
    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setResumes(result?.data?.data?.resumeList);
          setPageCount(result?.data?.data?.totalCount);
        } else if (result.data.resultStatusInfo.resultCode === "NOT_FOUND") {
          setResumes([]);
          setPageCount(0);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const viewResumeApi = (resumeId) => {
    const url = `${viewResume}?resumeIdentifier=${
      resumeId || null
    }&userIdentifier=${userDetail?.userIdentifier}`;

    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          window.open(result?.data?.data, "_blank");
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  const deleteResumeApi = (resumeId) => {
    const url = `${deleteResume}?userIdentifier=${userDetail?.userIdentifier}&resumeIdentifier=${
      resumeId || null
    }`;

    setLoading(true);

    WebUtils.httpOperations(url, {}, "DELETE")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setDeleteResumeTrigger((prev) => prev + 1);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  const resumeRenameApi = (resumeId, fileName) => {
    const url = `${renameResumeFile}`;

    let reqBody = {
      resumeIdentifier: resumeId,
      resumeFileName: fileName,
      userIdentifier: userDetail?.userIdentifier,
    };
    setLoading(true);

    WebUtils.httpOperations(url, reqBody, "POST")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setResumes((prev) =>
            prev.map((resume) =>
              resume.resumeIdentifier === resumeId
                ? {
                    ...resume,
                    resumeFileName: fileName,
                  }
                : resume,
            ),
          );

          notification.success({
            message: "Success",
            description: "Resume file renamed successfully!",
          });
        } else {
          notification.error({
            message: "Failed",
            // description: "Resume file name changed successfully!",
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const refreshApis = () => {
    // getGuideDetails();
    // getStudents(0, 5, "");
    // getAllResumes()
  };

  const onPageChange = (num, pageSize) => {
    setCurrentPage(num - 1);
    setPageSize(pageSize);
  };

  const sortItems = [
    {
      key: "SORT_BY_CREATION_DATE_ASC",
      label: "Creation Date (Old-New)",
    },
    {
      key: "SORT_BY_CREATION_DATE_DESC",
      label: "Creation Date (New-Old)",
    },
    {
      key: "SORT_BY_FILE_NAME_ASC",
      label: "File Name (A-Z)",
    },
    {
      key: "SORT_BY_FILE_NAME_DESC",
      label: "File Name (Z-A)",
    },
  ];

  useEffect(() => {
    getAllResumes(currentPage, pageSize, searchValue);
  }, [
    pageSize,
    currentPage,
    sortBy,
    searchValue,
    resumeState,
    deleteResumeTrigger,
  ]);

  return (
    <div className="mt-3">
      <>
        <ResumeSearchSec
          searchText={searchText}
          setSearchText={setSearchText}
          resumes={resumes}
          setSearchValue={setSearchValue}
          searchValue={searchValue}
          selectedUserIds={selectedUserIds}
          setDeleteResumeTrigger={setDeleteResumeTrigger}
          unAssignStudentFlag={unAssignStudentFlag}
          setUnAssignStudentFlag={setUnAssignStudentFlag}
          sortBy={sortBy}
          setSortBy={setSortBy}
          sortItems={sortItems}
          setResumeState={setResumeState}
          resumeState={resumeState}
        />

        <ResumeTable
          resumes={resumes}
          setSelectedUserIds={setSelectedUserIds}
          selectedUserIds={selectedUserIds}
          unAssignStudentFlag={unAssignStudentFlag}
          setUnAssignStudentFlag={setUnAssignStudentFlag}
          viewResumeApi={viewResumeApi}
          deleteResumeApi={deleteResumeApi}
          resumeRenameApi={resumeRenameApi}
          singleSkeletonLoading={singleSkeletonLoading}
        />

        <div className="flex justify-center mt-3 mb-1">
          <Pagination
            current={currentPage + 1}
            total={pageCount}
            pageSize={pageSize}
            onChange={onPageChange}
            showSizeChanger={true} // ✅ enable page size selector
            pageSizeOptions={["5", "10", "15", "20"]} // options for items per page
          />
        </div>
      </>
    </div>
  );
};

export default AllResumesMain;
